export default {"src":"/_next/static/media/tinkoff-logo.7136848f.svg","height":29,"width":88};